import { Fragment, useState, useEffect, useRef, useCallback } from "react";
import BTDialogBox from "../../components/BTDialgBox";
import BTInput from "../../components/BTInput";
import BTButton from "../../components/BTButton";
import BTBox from "../../components/BTBox";
import BTLoader from "../../components/BTLoader";
import {
  CircularProgress,
  Grid2 as Grid,
  Tooltip,
  Zoom,
  IconButton,
  Autocomplete,
  TextField,
  Box,
} from "@mui/material";
import * as XLSX from "xlsx";
import { Delete } from "@mui/icons-material";
import secureLocalStorage from "react-secure-storage";
import moment from "moment";
import authService from "../../services/auth-service";
import EnhancedTable from "../../components/BTTable";
import { useNotification, useLoading } from "../../context";
import { Notifications, Error } from "@mui/icons-material";
import { batchUpdate } from "../../store/labSlice";
import { manage_store_data } from "../../store/functions";
import { useDispatch } from "react-redux";
const Addresult = ({ open, setOpen, type }) => {
  const { u_id, u_type, admin_u_id } = secureLocalStorage.getItem("userdata");
  const filterOptions = [
    { value: "all", label: "All" },
    { value: "verified", label: "Verified" },
    { value: "unverified", label: "Unverified" },
  ];
  const dispatch = useDispatch();
  const initialState = {
    results: {
      stn_id: null,
      admin_u_id: u_type === 1 ? u_id : admin_u_id,
      p_id: null,
      document_no: null,
      report_date: null,
      report_number: null,
      prefix: null,
      other_report_number: null,
      shape_name: null,
      weight: null,
      number_stones: null,
      description: null,
      measurement1: null,
      measurement2: null,
      measurement3: null,
      table: null,
      crown_height: null,
      pavilion_depth: null,
      total_depth: null,
      crown_angle: null,
      pavilion_angle: null,
      culet_size: null,
      girdle_percent: null,
      girdle_name: null,
      pol_or_pol_sym: null,
      sym: null,
      cut_prop: null,
      clarity: null,
      color_long: null,
      report_type_i: null,
      report_format_i: null,
      color_short: null,
      report_type_ii: null,
      report_format_ii: null,
      fluorescence: null,
      comments_consultation: null,
      special_comments: null,
      report_comment: null,
      customer_ref_no: null,
      memo_no: null,
      fax_comments: null,
      laserscribe: null,
      recheck: null,
      key_to_symbols: null,
      lp: null,
      res_desc: null,
      res_deleted: null,
      res_date: moment().format("YYYY-MM-DD"),
      res_type: 1,
      sub_results: [],
      res_created_by: u_id,
      res_updated_by: u_id,
    },
  };
  const fileInputRef = useRef(null);
  const [formData, setFormData] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState(filterOptions[0]);
  const { addNotification } = useNotification();
  const { showLoading, hideLoading } = useLoading();
  const sub_count =
    formData?.results?.sub_results?.reduce(
      (total, item) => total + (Number(item?.number_stones) || 0),
      0
    ) || 0;
  const sub_weight =
    formData?.results.sub_results?.reduce(
      (total, item) => total + (Number(item?.weight) || 0),
      0
    ) || 0;

  const handleClose = () => {
    setOpen(null);
    setFormData(initialState);
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      results: {
        ...prev.results,
        [name]: value,
      },
    }));
  };

  const handleFilterChange = (event, newValue) => {
    setFilter(newValue);
  };

  const submitResults = async (e) => {
    e.preventDefault();
    const finalFormData = {
      results: {
        ...formData?.results,
        number_stones: sub_count,
        weight: +sub_weight?.toFixed(2),
      },
    };
    const deleteRec = formData?.results.sub_results?.filter(
      ({ res_deleted }) => res_deleted
    );

    try {
      setLoading(true);
      const response = await authService?.insert_result({
        attributes: {
          results: { ...finalFormData.results, final_submit: true },
        },
      });

      if (response?.status && response?.status_code === 200) {
        const { results, submits, ...data } = response?.data;
        const updateRec = type ? results : [data];
        dispatch(
          batchUpdate({
            name: "submission",
            key: "stn_id",
            insert: [],
            updateItems: submits,
            removeItems: [],
          })
        );
        dispatch(
          batchUpdate({
            name: "result",
            key: "res_id",
            insert: updateRec,
            updateItems: [],
            removeItems: deleteRec,
          })
        );
        addNotification({
          icon: <Notifications color="white" />,
          title: "Success!",
          message: response?.message,
          color: "success",
        });
        handleClose();
      } else {
        const { results } = response?.data;
        setFormData((prev) => ({
          ...prev,
          results: {
            ...prev.results,
            sub_results: results,
          },
        }));
        addNotification({
          icon: <Notifications color="white" />,
          title: "Error!",
          message: response?.message,
          color: "error",
        });
        return;
      }
      // if (response?.status_code === 206) {
      //   const { results } = response?.data;
      //   setFormData((prev) => ({
      //     ...prev,
      //     results: {
      //       ...prev.results,
      //       sub_results: results,
      //     },
      //   }));
      //   addNotification({
      //     icon: <Notifications color="white" />,
      //     title: "Error!",
      //     message: response?.message,
      //     color: "error",
      //   });
      //   return;
      // } else {
      //   const { results, submits, ...data } = response?.data;
      //   manage_store_data({
      //     name: "results",
      //     key: "res_id",
      //     data: [data, ...results],
      //     type: "update",
      //     total: type === 1 ? total + 1 : total + results?.length,
      //   });
      //   manage_store_data({
      //     name: "submissions",
      //     key: "stn_id",
      //     data: submits,
      //     type: "update",
      //     total: null,
      //   });
      //   setRefresh((prev) => !prev);
      //   addNotification({
      //     icon: <Notifications color="white" />,
      //     title: "Success!",
      //     message: response?.message,
      //     color: "success",
      //   });

      //   handleClose();
      // }
    } catch (error) {
      addNotification({
        icon: <Error color="white" />,
        title: "Error!",
        message: error?.response?.data?.message || "Something went wrong",
        color: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const renderField = (field, onChange, record) => {
    if (field.name === "res_date") {
      return (
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <BTInput
            name={field.name}
            label={field.label}
            type={field.type || "text"}
            value={record[field.name] || ""}
            onChange={onChange}
            variant="standard"
            required={field.required}
            fullWidth
            {...field.props}
          />
          <Autocomplete
            options={filterOptions}
            getOptionLabel={(option) => option.label}
            disableClearable
            value={filter}
            onChange={handleFilterChange}
            sx={{ width: "300px" }}
            renderInput={(params) => (
              <TextField {...params} label="Filter" variant="standard" />
            )}
          />
        </Box>
      );
    }
    return (
      <BTInput
        name={field.name}
        label={field.label}
        type={field.type || "text"}
        value={record[field.name] || ""}
        onChange={onChange}
        variant="standard"
        required={field.required}
        fullWidth
        {...field.props}
      />
    );
  };

  const updateDates = useCallback((date) => {
    setFormData((prev) => ({
      results: {
        ...prev.results,
        res_date: date,
        sub_results: prev.results.sub_results.map((item) => ({
          ...item,
          res_date: date,
        })),
      },
    }));
  }, []);

  useEffect(() => {
    if (formData.results.res_date) {
      updateDates(formData.results.res_date);
    }
  }, [formData.results.res_date, updateDates]);

  const handleDeleteRow = (rowOrRows) => {
    setFormData((prev) => {
      const rowsToDelete = Array.isArray(rowOrRows) ? rowOrRows : [rowOrRows];
      const refNosToDelete = new Set(
        rowsToDelete.map((row) => row?.customer_ref_no)
      );
      return {
        results: {
          ...prev.results,
          sub_results: prev.results.sub_results.filter(
            (item) => !refNosToDelete.has(item?.customer_ref_no)
          ),
        },
        // submits: prev.submits.filter(
        //   (item) => !refNosToDelete.has(item?.stn_cus_ref_no)
        // ),
      };
    });
  };
  const handleFileChange = async (event) => {
    const selectedFiles = Array.from(event.target.files);
    if (!selectedFiles.length) return;

    try {
      showLoading();
      let resultsData = [];
      let isValid = false;
      for (const selectedFile of selectedFiles) {
        const fileResult = await processSingleFile(selectedFile);
        if (fileResult.error) {
          isValid = true;
          addNotification({
            icon: <Error color="white" />,
            title: "Invalid File!",
            message: fileResult.error,
            color: "error",
          });
          continue;
        }
        resultsData = [...resultsData, ...fileResult.resultsData];
      }
      if (!isValid) {
        try {
          const obj = {
            results: {
              ...formData?.results,
              sub_results: resultsData,
              final_submit: false,
            },
          };

          const response = await authService?.insert_result({
            attributes: obj,
          });

          const isError = response?.status_code === 206;
          const { results } = response?.data || [];
          setFormData((prev) => ({
            ...prev,
            results: {
              ...prev.results,
              sub_results: results,
            },
          }));
          addNotification({
            icon: <Notifications color="white" />,
            title: isError ? "Error!" : "Successfully!",
            message: response?.message,
            color: isError ? "warning" : "success",
          });
        } catch (error) {
          addNotification({
            icon: <Error color="white" />,
            title: "Error!",
            message:
              error?.response?.data?.message || "Failed to uploads results",
            color: "error",
          });
        }
      }
    } catch (error) {
      addNotification({
        icon: <Error color="white" />,
        title: "Error!",
        message: "An unexpected error occurred while processing files.",
        color: "error",
      });
    } finally {
      hideLoading();
    }
  };

  // Helper function to process individual file
  const processSingleFile = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const data = e.target.result;
          const workbook = XLSX.read(data, {
            type: file.name.endsWith(".csv") ? "string" : "binary",
          });
          const worksheet = workbook.Sheets[workbook.SheetNames[0]];

          const requiredColumns = [
            "Customer Ref No.",
            "Document No",
            "Report Date",
            "Report Number",
            "Other Report Number",
            "Prefix",
            "Weight",
            "Number Stones",
            "Description",
            "Laserscribe",
            "POL or Pol/Sym",
            "CUT-PROP",
            "Shape Name",
            "SYM",
            "Clarity",
            "Fluorescence",
            "Key To Symbols",
            "Table",
            "Measurement1",
            "Measurement2",
            "Measurement3",
            "Crown Height",
            "Pavilion Depth",
            "Total Depth",
            "Crown Angle",
            "Pavilion Angle",
            "Culet Size",
            "Girdle Percent",
            "Girdle Name",
            "Color (Long)",
            "Color (Short)",
            "Report Comment",
            "Memo No",
            "Fax Comments",
            "Comments Consultation",
            "Special Comments",
            "Report Comment",
            "Report Type I",
            "Report Format I",
            "Report Type II",
            "Report Format II",
            "Recheck",
            "LP",
          ];

          // Validate file structure
          const range = XLSX.utils.decode_range(worksheet["!ref"]);
          const actualColumns = [];
          for (let C = range.s.c; C <= range.e.c; ++C) {
            const cellAddress = { c: C, r: 0 };
            const cellRef = XLSX.utils.encode_cell(cellAddress);
            actualColumns.push(worksheet[cellRef]?.v.trim());
          }

          const missingColumns = requiredColumns.filter(
            (col) => !actualColumns.includes(col)
          );

          if (missingColumns.length > 0) {
            return resolve({
              error: `Missing columns in ${file.name}: ${missingColumns.join(
                ", "
              )}`,
              transformedResults: [],
            });
          }

          const jsonResult = XLSX.utils
            .sheet_to_json(worksheet, {
              defval: "",
            })
            .map((item) => {
              const newItem = {};
              for (const key in item) {
                const newKey = key.trim();
                newItem[newKey] = item[key];
              }
              return newItem;
            });

          // Process data
          const resultsData = jsonResult.map((excelItem) => ({
            admin_u_id: u_type === 1 ? u_id : admin_u_id,
            res_type: 2,
            document_no: excelItem["Document No"],
            report_date: excelItem["Report Date"],
            report_number: excelItem["Report Number"],
            prefix: excelItem["Prefix"],
            other_report_number: excelItem["Other Report Number"],
            shape_name: excelItem["Shape Name"],
            weight: excelItem["Weight"],
            number_stones: excelItem["Number Stones"],
            description: excelItem["Description"],
            measurement1: excelItem["Measurement1"],
            measurement2: excelItem["Measurement2"],
            measurement3: excelItem["Measurement3"],
            table: excelItem["Table"],
            crown_height: excelItem["Crown Height"],
            pavilion_depth: excelItem["Pavilion Depth"],
            total_depth: excelItem["Total Depth"],
            crown_angle: excelItem["Crown Angle"],
            pavilion_angle: excelItem["Pavilion Angle"],
            culet_size: excelItem["Culet Size"],
            girdle_percent: excelItem["Girdle Percent"],
            girdle_name: excelItem["Girdle Name"],
            pol_or_pol_sym: excelItem["POL or Pol/Sym"],
            sym: excelItem["SYM"],
            cut_prop: excelItem["CUT-PROP"],
            clarity: excelItem["Clarity"],
            color_long: excelItem["Color (Long)"],
            report_type_i: excelItem["Report Type I"],
            report_format_i: excelItem["Report Format I"],
            color_short: excelItem["Color (Short)"],
            report_type_ii: excelItem["Report Type II"],
            report_format_ii: excelItem["Report Format II"],
            fluorescence: excelItem["Fluorescence"],
            comments_consultation: excelItem["Comments Consultation"],
            special_comments: excelItem["Special Comments"],
            report_comment: excelItem["Report Comment"],
            customer_ref_no: excelItem["Customer Ref No."],
            memo_no: excelItem["Memo No"],
            fax_comments: excelItem["Fax Comments"],
            laserscribe: excelItem["Laserscribe"],
            recheck: excelItem["Recheck"],
            key_to_symbols: excelItem["Key To Symbols"],
            lp: excelItem["LP"],
            res_desc: null,
            res_deleted: null,
            res_date: formData.results.res_date,
            res_created_by: u_id,
            res_updated_by: u_id,
            error_msg: null,
            verify: true,
          }));

          resolve({
            resultsData,
            error: null,
          });
        } catch (error) {
          resolve({
            error: `Invalid format in ${file.name}: Please upload a valid Excel or CSV file.`,
            resultsData: [],
          });
        }
      };

      reader.onerror = () => {
        resolve({
          error: `Error reading file ${file.name}`,
          transformedResults: [],
          updatedSubmits: [],
        });
      };

      reader.readAsBinaryString(file);
    });
  };

  const columns = [
    {
      id: "id",
      name: "ID",
      selector: (row, index) => index + 1,
      width: "50px",
    },
    {
      id: "report_date",
      name: "Report Date",
      selector: (row) => row.report_date,
      width: "100px",
    },
    {
      id: "report_number",
      name: "Report Number",
      selector: (row) => row.report_number,
      width: "100px",
    },
    {
      id: "shape_name",
      name: "Shape Name",
      selector: (row) => row.shape_name,
      width: "150px",
    },
    {
      id: "weight",
      name: "Weight",
      selector: (row) => row.weight,
      width: "50px",
    },
    {
      id: "description",
      name: "Description",
      selector: (row) => row.description,
      width: "150px",
    },
    {
      id: "pol_or_pol_sym",
      name: "POL or Pol/Sym",
      selector: (row) => row.pol_or_pol_sym,
      width: "150px",
    },
    { id: "sym", name: "SYM", selector: (row) => row.sym, width: "150px" },
    {
      id: "cut_prop",
      name: "CUT-PROP",
      selector: (row) => row.cut_prop,
      width: "150px",
    },
    {
      id: "clarity",
      name: "Clarity",
      selector: (row) => row.clarity,
      width: "150px",
    },
    {
      id: "fluorescence",
      name: "Fluorescence",
      selector: (row) => row.fluorescence,
      width: "150px",
    },
    {
      id: "stn_prefix_ref_no",
      name: "Prefix No",
      selector: (row) => row?.stn_prefix_ref_no,
      width: "100px",
    },
    {
      id: "customer_ref_no",
      name: "Customer Ref No.",
      selector: (row) => row.customer_ref_no,
      width: "150px",
    },
    {
      id: "laserscribe",
      name: "Laserscribe",
      selector: (row) => row.laserscribe,
      width: "150px",
    },
    {
      id: "recheck",
      name: "Recheck",
      selector: (row) => row.recheck,
      width: "300px",
    },
    {
      id: "verified_status",
      name: "Varified status",
      selector: (row) => row?.error_msg,
      width: "200px",
    },
    {
      id: "actions",
      name: "Actions",
      selector: (row, index) => (
        <Tooltip title="Delete" TransitionComponent={Zoom}>
          <IconButton size="small" onClick={() => handleDeleteRow(row)}>
            <Delete fontSize="12px" color="error" />
          </IconButton>
        </Tooltip>
      ),
      width: "50px",
      bodyCellStyle: {
        padding: "0px",
      },
    },
  ];
  const sharedFieldsConfig = [
    {
      name: "res_date",
      label: "Date",
      type: "date",
      required: true,
    },
  ];
  const filteredResults =
    filter.value === "all"
      ? formData.results.sub_results
      : formData.results.sub_results.filter((item) =>
          filter.value === "verified" ? item.verify : !item.verify
        );

  return (
    <BTDialogBox
      open={Boolean(open)}
      fullWidth
      maxWidth={"xll"}
      maxHeight={"500px"}
      minHeight={"500px"}
      onSubmit={submitResults}
      close={handleClose}
      title={"Add Result"}
      buttons={[
        {
          name: "Cancel",
          color: "secondary",
          size: "small",
          onClick: handleClose,
        },
        {
          name: "Submit",
          variant: "gradient",
          type: "submit",
          color: "dark",
          size: "small",
          loading: loading,
          loadingComponent: (
            <Fragment>
              <svg width={0} height={0}>
                <defs>
                  <linearGradient
                    id="my_gradient"
                    x1="0%"
                    y1="0%"
                    x2="0%"
                    y2="100%">
                    <stop offset="0%" stopColor="#e01cd5" />
                    <stop offset="100%" stopColor="#1CB5E0" />
                  </linearGradient>
                </defs>
              </svg>
              <CircularProgress
                size={22}
                sx={{
                  "svg circle": { stroke: "url(#my_gradient)" },
                }}
              />
            </Fragment>
          ),
          disabled:
            formData.results.sub_results?.some((item) => !item.verify) ||
            formData.results.sub_results?.length === 0 ||
            loading,
          sx: { ml: 2, width: "80px" },
        },
      ]}>
      <BTLoader />
      <Grid container spacing={2}>
        {sharedFieldsConfig.map((field, index) => (
          <Grid size={{ xs: 12, md: 3 }} key={`main-${index}`}>
            {renderField(field, handleChange, formData.results)}
          </Grid>
        ))}
        <Grid
          size={{ xs: 12, md: 3 }}
          display="flex"
          gap={1}
          alignItems="center"
          mt={1}>
          <BTButton
            variant="gradient"
            onClick={handleButtonClick}
            color="dark"
            size="small"
            sx={{ width: "80px" }}
            fullWidth>
            Upload
          </BTButton>
          <input
            type="file"
            ref={fileInputRef}
            multiple={true}
            onChange={handleFileChange}
            style={{ display: "none" }}
            accept=".xlsx,.xls,.csv"
          />
        </Grid>
      </Grid>
      <BTBox mt={2}>
        <EnhancedTable
          rows={filteredResults}
          checkBoxSelected={true}
          tableHeader={true}
          title="Details"
          onDeleteSelected={handleDeleteRow}
          columns={columns}
          pagination={true}
          getRowStyle={(row) => {
            if (!row?.verify) {
              return {
                backgroundColor: "#fbd1d3",
                "&:hover": {
                  backgroundColor: "#d0e9d1",
                },
              };
            } else {
              return {
                backgroundColor: "#ddffdd",
                "&:hover": {
                  backgroundColor: "#d0e9d1",
                },
              };
            }
          }}
        />
      </BTBox>
    </BTDialogBox>
  );
};

export default Addresult;
